import React, { FunctionComponent, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import {
  getApplicationModeState,
  getApplicationBreakpointState,
  getStatisticsStatus,
} from '../../selectors';
import { ApplicationMode, ApplicationBreakpoint, Tab, Status } from '../../types';
import { Title } from '../../components/Title';
import { MobileTitle } from '../../components/MobileTItle';

import './StatisticsPage.scss';
import { StatisticsYearTab } from '../../components/StatisticsYearTab/StatisticsYearTab';
import { getStatistics } from '../../selectors';
import { setStatistics } from '../../actions';
import { NoMatches } from '../../components/NoMatches';

import { useHistory, useLocation } from 'react-router-dom';

import { MatchTableType } from '../../components/MatchTable';
import { ContentLoader } from '../../components/ContentLoader';

export const StatisticsPage: FunctionComponent<{}> = () => {
  const { t } = useTranslation();
  const applicationMode = useSelector(getApplicationModeState);
  const applicationBreakpoint = useSelector(getApplicationBreakpointState);
  const history = useHistory();
  const location = useLocation();

  const statisticsPageClasses = ['StatisticsPage'];
  if (applicationMode === ApplicationMode.dark) statisticsPageClasses.push('StatisticsPage--dark');
  const dispatch = useDispatch();

  const seasons = useSelector(getStatistics);
  const status = useSelector(getStatisticsStatus);

  const redirectToNewMatch = () => {
    history.replace(location.pathname);
    history.push(`/match-detail?isNew=true`);
  };

  useEffect(() => {
    dispatch(setStatistics());
  }, [dispatch]);

  const tabs: Tab[] = [];

  seasons.sort((a, b) => {
    let yearA = a.season.length > 4 ? Number(a.season.substring(0, 4)) : Number(a.season);
    let yearB = b.season.length > 4 ? Number(b.season.substring(0, 4)) : Number(b.season);
    yearA = isNaN(yearA) ? -1 : yearA;
    yearB = isNaN(yearB) ? -1 : yearB;

    return yearB - yearA;
  });

  seasons.forEach((s, i) => {
    if (s.season === 'All seasons' && seasons.length <= 2) return;

    tabs.push({
      id: i,
      name: t(s.season),
    });
  });

  const [activeTab, setActiveTab] = useState<Tab>(tabs[0]); // getNoteTabFromLocalStorage(tabs) ||
  if (!activeTab && tabs[0]) setActiveTab(tabs[0]);

  return (
    <div className={statisticsPageClasses.join(' ')}>
      {applicationBreakpoint === ApplicationBreakpoint.desktop ? (
        <Title
          title={t('statistics')}
          tabs={tabs}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
      ) : (
        <MobileTitle
          title={t('statistics')}
          tabs={tabs}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
      )}
      <div className="StatisticsPage__content">
        {seasons && activeTab && seasons[activeTab.id] && (
          <StatisticsYearTab
            year={seasons[activeTab.id].season}
            link={seasons[activeTab.id].link}
          />
        )}
        {seasons && seasons.length === 0 && status === Status.success && (
          <div style={{ margin: '0px auto' }}>
            <NoMatches type={MatchTableType.noData} redirectToNewMatch={redirectToNewMatch} />
          </div>
        )}

        {status === Status.requesting && <ContentLoader />}
      </div>
    </div>
  );
};
